import { createFileRoute } from '@tanstack/react-router';
import { OrganizationDetailPage } from '@/features/organizations';

export const Route = createFileRoute('/_auth/organizations/$orgId')({
  component: OrganizationDetailRoute,
});

function OrganizationDetailRoute() {
  const { orgId } = Route.useParams();
  return <OrganizationDetailPage orgId={orgId} />;
}
